import { cn } from "@discovery/classnames";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderBlocks } from "../../components/molecules/rich-text-data";
import * as styles from "./styles.css";
import { Component } from "react";
export const view = (bodyM) => React.createElement(Article, { bodyM: bodyM });
export var ArticleFlavors;
(function (ArticleFlavors) {
    ArticleFlavors["BASIC"] = "basic";
    ArticleFlavors["CONTACTUS"] = "contactUs";
})(ArticleFlavors || (ArticleFlavors = {}));
export class Article extends Component {
    render() {
        const { bodyM } = this.props;
        const path = window.location.pathname;
        const type = path === "/contact-us" ? ArticleFlavors.CONTACTUS : ArticleFlavors.BASIC;
        return (React.createElement("div", { className: path === "/contact-us" ? styles.contactUSwrapper : styles.wrapper },
            React.createElement("div", { className: cn(styles.article, styles[type]) },
                React.createElement(RenderMaybe, null, M.map((b) => (React.createElement(RenderBlocks, { ast: b })), bodyM)))));
    }
}

